export const FirebaseConfig = {
	"projectId": "taxi-app-f9b59",
	"appId": "1:618853741667:web:c0c0d1b08221ed1e70f456",
	"databaseURL": "https://taxi-app-f9b59-default-rtdb.firebaseio.com",
	"storageBucket": "taxi-app-f9b59.firebasestorage.app",
	"apiKey": "AIzaSyDnttE3fMqAZyvJN9z0zxQUBhfGAaxdBXs",
	"authDomain": "taxi-app-f9b59.firebaseapp.com",
	"messagingSenderId": "618853741667",
	"measurementId": "G-QMS7F7MCTX"
};